import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../Button';

const SimpleTabs = ({
  activeTab,
  ariaLabel,
  className,
  onTabChange,
  tabActiveClassName,
  tabClassName,
  tabs,
}) => (
  <div className={className} role="tablist" aria-label={ariaLabel}>
    {tabs.map((tab) => {
      const isActive = activeTab === tab.id;
      return (
        <Button
          key={tab.id}
          variant="no-style"
          role="tab"
          className={cx(tabClassName, { [tabActiveClassName]: isActive })}
          aria-selected={isActive}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </Button>
      );
    })}
  </div>
);

SimpleTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  onTabChange: PropTypes.func.isRequired,
  tabActiveClassName: PropTypes.string,
  tabClassName: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};

SimpleTabs.defaultProps = {
  ariaLabel: 'Tabs',
  className: undefined,
  tabActiveClassName: undefined,
  tabClassName: undefined,
};

SimpleTabs.displayName = 'SimpleTabs';

export default SimpleTabs;
